// Modules
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';

// Rxjs
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

// Constants
import { APP_PATHS_CONSTANTS } from '@shared/constants';

// Reducer
import { AppState } from '@store/reducers';

// Selectors
import * as ForcedPasswordChangeSelectors from '@store/selectors/forced-password-change.selectors';

@Injectable({
  providedIn: 'root',
})
export class ForcedPasswordChangeGuard {
  // Constructor
  constructor(
    private _store: Store<AppState>,
    private _router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this._store.pipe(
      select(ForcedPasswordChangeSelectors.selectForcedPasswordChangeCanAccess),
      map(canAccess => {
        if (!canAccess) {
          this._router.navigateByUrl(APP_PATHS_CONSTANTS.ADMIN_LOGIN);
          return false;
        }
        return true;
      }),
      take(1)
    );
  }
}
